<template>
  <div class="permisos">
    <div class="encabezado">
      <h2>Usuarios y permisos</h2>
      <router-link v-if="puedeConfig" to="/admin/config" class="link-secundario">Configuración del sitio →</router-link>
    </div>

    <div class="tabs">
      <button v-for="t in TABS" :key="t.id" :class="{ activa: tab === t.id }" @click="tab = t.id">{{ t.nombre }}</button>
    </div>

    <div v-if="error" class="msg error">{{ error }}</div>
    <div v-if="ok" class="msg exito">{{ ok }}</div>
    <div v-if="cargando" class="cargando">Cargando…</div>

    <!-- ===================== USUARIOS ===================== -->
    <section v-if="!cargando && tab === 'usuarios'">
      <button class="btn" @click="nuevoUsuario = nuevoUsuario ? null : usuarioVacio()">
        {{ nuevoUsuario ? 'Cancelar' : '+ Nuevo usuario' }}
      </button>

      <form v-if="nuevoUsuario" class="tarjeta" @submit.prevent="crearUsuario">
        <h3>Nuevo usuario</h3>
        <div class="campos">
          <label>Usuario <input v-model.trim="nuevoUsuario.username" required pattern="[A-Za-z0-9_.\-]{3,50}" /></label>
          <label>Nombre <input v-model.trim="nuevoUsuario.full_name" /></label>
          <label>Correo <input v-model.trim="nuevoUsuario.email" type="email" required /></label>
          <label>Contraseña (mín. {{ CLAVE_MINIMA }}) <input v-model="nuevoUsuario.password" type="password" required :minlength="CLAVE_MINIMA" autocomplete="new-password" /></label>
        </div>
        <div class="grupos-check">
          <span>Grupos:</span>
          <label v-for="g in grupos" :key="g.codigo"><input type="checkbox" :value="g.codigo" v-model="nuevoUsuario.grupos" /> {{ g.nombre }}</label>
        </div>
        <button class="btn" type="submit" :disabled="guardando">Crear</button>
      </form>

      <table class="tabla">
        <thead>
          <tr><th>Usuario</th><th>Nombre</th><th>Grupos</th><th>Estado</th><th>Último ingreso</th><th></th></tr>
        </thead>
        <tbody>
          <template v-for="u in usuarios" :key="u.id">
            <tr :class="{ inactivo: !u.is_active }">
              <td><b>{{ u.username }}</b><div class="sub">{{ u.email }}</div></td>
              <td>{{ u.full_name || '—' }}</td>
              <td>
                <span v-for="c in u.grupos" :key="c" class="chip">{{ nombreGrupo(c) }}</span>
                <span v-if="!u.grupos.length" class="sub">sin grupos (no ve nada)</span>
              </td>
              <td>{{ u.is_active ? 'Activo' : 'Inactivo' }}</td>
              <td>{{ fecha(u.last_login) }}</td>
              <td class="acciones">
                <button class="btn chico" @click="abrir(u, 'editar')">Editar</button>
                <button class="btn chico" @click="abrir(u, 'clave')">Contraseña</button>
                <button class="btn chico" @click="abrir(u, 'ver')">Ver permisos</button>
              </td>
            </tr>
            <tr v-if="abierto && abierto.id === u.id" class="detalle">
              <td colspan="6">
                <form v-if="modo === 'editar'" @submit.prevent="guardarUsuario">
                  <div class="campos">
                    <label>Nombre <input v-model.trim="edicion.full_name" /></label>
                    <label>Correo <input v-model.trim="edicion.email" type="email" required /></label>
                    <label class="en-linea"><input type="checkbox" v-model="edicion.is_active" /> Activo (puede iniciar sesión)</label>
                  </div>
                  <div class="grupos-check">
                    <span>Grupos:</span>
                    <label v-for="g in grupos" :key="g.codigo"><input type="checkbox" :value="g.codigo" v-model="edicion.grupos" /> {{ g.nombre }}</label>
                  </div>
                  <button class="btn" type="submit" :disabled="guardando">Guardar</button>
                  <button class="btn gris" type="button" @click="abierto = null">Cerrar</button>
                </form>

                <form v-if="modo === 'clave'" @submit.prevent="guardarClave">
                  <div class="campos">
                    <label>Nueva contraseña (mín. {{ CLAVE_MINIMA }}) <input v-model="clave1" type="password" required :minlength="CLAVE_MINIMA" autocomplete="new-password" /></label>
                    <label>Repetir <input v-model="clave2" type="password" required autocomplete="new-password" /></label>
                  </div>
                  <button class="btn" type="submit" :disabled="guardando">Cambiar contraseña</button>
                  <button class="btn gris" type="button" @click="abierto = null">Cerrar</button>
                </form>

                <div v-if="modo === 'ver'">
                  <p v-if="!efectivos">Cargando…</p>
                  <template v-else>
                    <p v-if="efectivos.es_admin"><b>Administra usuarios y permisos.</b></p>
                    <p v-if="!Object.keys(efectivos.recursos).length">No tiene acceso a nada.</p>
                    <ul class="efectivos">
                      <li v-for="cat in catalogo" :key="cat.codigo" v-show="cat.recursos.some(r => efectivos.recursos[r.codigo])">
                        <b>{{ cat.nombre }}</b>
                        <ul>
                          <li v-for="r in cat.recursos.filter(r => efectivos.recursos[r.codigo])" :key="r.codigo">
                            {{ r.nombre }}: <span :class="'nivel-' + efectivos.recursos[r.codigo]">{{ efectivos.recursos[r.codigo] }}</span>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </template>
                  <button class="btn gris" type="button" @click="abierto = null">Cerrar</button>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </section>

    <!-- ===================== GRUPOS ===================== -->
    <section v-if="!cargando && tab === 'grupos'" class="grupos-layout">
      <aside class="lista-grupos">
        <button v-for="g in grupos" :key="g.codigo" :class="{ activa: grupoSel && grupoSel.codigo === g.codigo && !grupoSel.nuevo }" @click="elegirGrupo(g)">
          {{ g.nombre }} <span class="sub">({{ g.miembros.length }})</span>
        </button>
        <button class="nuevo" @click="elegirGrupo(null)">+ Nuevo grupo</button>
      </aside>

      <div v-if="grupoSel" class="tarjeta editor-grupo">
        <div class="campos">
          <label v-if="grupoSel.nuevo">Código <input v-model.trim="grupoSel.codigo" required pattern="[a-z0-9_]{2,50}" placeholder="ej. finanzas" /></label>
          <label>Nombre <input v-model.trim="grupoSel.nombre" required /></label>
          <label class="ancho">Descripción <input v-model.trim="grupoSel.descripcion" /></label>
        </div>
        <p v-if="!grupoSel.nuevo" class="sub">
          Miembros: {{ miembros(grupoSel).join(', ') || 'ninguno' }} — se asignan en la pestaña Usuarios.
        </p>

        <table class="matriz">
          <thead><tr><th>Permiso</th><th>Sin acceso</th><th>Leer</th><th>Leer y escribir</th></tr></thead>
          <tbody>
            <tr class="fila-todo">
              <td><b>Todo</b> <span class="sub">(todas las categorías, incluida Administración)</span></td>
              <td v-for="n in [0, 1, 2]" :key="n"><input type="radio" name="n-todo" :value="n" v-model="niveles['*']" /></td>
            </tr>
            <template v-for="cat in catalogo" :key="cat.codigo">
              <tr class="fila-cat">
                <td><b>{{ cat.nombre }}</b> <span class="sub">(todo el módulo)</span></td>
                <td v-for="n in [0, 1, 2]" :key="n">
                  <input type="radio" :name="'n-cat-' + cat.codigo" :value="n" :checked="efectivo('cat:' + cat.codigo) === n" :disabled="n < heredado('cat:' + cat.codigo)"
                         @change="niveles['cat:' + cat.codigo] = n" />
                </td>
              </tr>
              <tr v-for="r in cat.recursos" :key="r.codigo" class="fila-rec">
                <td>{{ r.nombre }} <span v-if="heredado(r.codigo)" class="sub">· heredado: {{ NOMBRE_NIVEL[heredado(r.codigo)] }}</span></td>
                <td v-for="n in [0, 1, 2]" :key="n">
                  <input type="radio" :name="'n-' + r.codigo" :value="n" :checked="efectivo(r.codigo) === n" :disabled="n < heredado(r.codigo)"
                         @change="niveles[r.codigo] = n" />
                </td>
              </tr>
            </template>
          </tbody>
        </table>

        <div class="botones">
          <button class="btn" @click="guardarGrupo" :disabled="guardando">{{ grupoSel.nuevo ? 'Crear grupo' : 'Guardar cambios' }}</button>
          <button v-if="!grupoSel.nuevo && !grupoSel.es_sistema" class="btn rojo" @click="borrarGrupo" :disabled="guardando">Borrar grupo</button>
          <span v-if="grupoSel.es_sistema" class="sub">Grupo del sistema: no se puede borrar.</span>
        </div>
      </div>
      <p v-else class="sub">Elige un grupo para ver o cambiar sus permisos.</p>
    </section>

    <!-- ===================== AUDITORÍA ===================== -->
    <section v-if="!cargando && tab === 'auditoria'">
      <table class="tabla">
        <thead><tr><th>Fecha</th><th>Quién</th><th>Qué</th><th>Detalle</th></tr></thead>
        <tbody>
          <tr v-for="a in auditoria" :key="a.id">
            <td class="nowrap">{{ fecha(a.fecha) }}</td><td>{{ a.usuario }}</td><td>{{ a.accion }}</td>
            <td><code class="detalle-json">{{ a.detalle }}</code></td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useStore } from 'vuex'
import permisosApi from '../../api/permisos'

const TABS = [
  { id: 'usuarios', nombre: 'Usuarios' },
  { id: 'grupos', nombre: 'Grupos y permisos' },
  { id: 'auditoria', nombre: 'Historial de cambios' },
]
const CLAVE_MINIMA = 10
const NIVEL = { leer: 1, escribir: 2, '*': 2 }
const NOMBRE_NIVEL = ['sin acceso', 'leer', 'leer y escribir']
const ACCION = [null, 'leer', 'escribir']

export default {
  name: 'PermisosAdmin',
  setup() {
    const store = useStore()
    const puedeConfig = computed(() => store.getters['auth/puede']('admin.config'))
    const tab = ref('usuarios')
    const cargando = ref(true)
    const guardando = ref(false)
    const error = ref(null)
    const ok = ref(null)
    const catalogo = ref([])
    const grupos = ref([])
    const usuarios = ref([])
    const auditoria = ref([])

    const avisar = (texto) => { ok.value = texto; error.value = null; setTimeout(() => { if (ok.value === texto) ok.value = null }, 4000) }
    const fallo = (e) => {
      const d = e.response?.data?.detail
      error.value = Array.isArray(d) ? d.map(x => x.msg).join('; ') : (d || e.message || 'Error')
      ok.value = null
    }
    const fecha = (f) => f ? new Date(f).toLocaleString('es-CL', { dateStyle: 'short', timeStyle: 'short' }) : '—'
    const nombreGrupo = (c) => grupos.value.find(g => g.codigo === c)?.nombre || c

    async function cargar() {
      cargando.value = true
      try {
        const [c, g, u] = await Promise.all([permisosApi.catalogo(), permisosApi.grupos(), permisosApi.usuarios()])
        catalogo.value = c.data
        grupos.value = g.data
        usuarios.value = u.data
      } catch (e) { fallo(e) } finally { cargando.value = false }
    }
    async function cargarAuditoria() {
      try { auditoria.value = (await permisosApi.auditoria()).data } catch (e) { fallo(e) }
    }
    watch(tab, t => { error.value = null; if (t === 'auditoria') cargarAuditoria() })
    // Si el admin se cambió sus propios permisos, que el menú lo refleje
    const refrescarMisPermisos = () => store.dispatch('auth/cargarPermisos').catch(() => {})

    // ---- Usuarios ----
    const usuarioVacio = () => ({ username: '', full_name: '', email: '', password: '', grupos: [] })
    const nuevoUsuario = ref(null)
    const abierto = ref(null)
    const modo = ref(null)
    const edicion = reactive({ email: '', full_name: '', is_active: true, grupos: [] })
    const clave1 = ref('')
    const clave2 = ref('')
    const efectivos = ref(null)

    async function crearUsuario() {
      guardando.value = true
      try {
        await permisosApi.crearUsuario(nuevoUsuario.value)
        avisar(`Usuario ${nuevoUsuario.value.username} creado`)
        nuevoUsuario.value = null
        await cargar()
      } catch (e) { fallo(e) } finally { guardando.value = false }
    }
    async function abrir(u, m) {
      abierto.value = u
      modo.value = m
      error.value = null
      if (m === 'editar') Object.assign(edicion, { email: u.email, full_name: u.full_name, is_active: u.is_active, grupos: [...u.grupos] })
      if (m === 'clave') { clave1.value = ''; clave2.value = '' }
      if (m === 'ver') {
        efectivos.value = null
        try { efectivos.value = (await permisosApi.efectivos(u.id)).data } catch (e) { fallo(e) }
      }
    }
    async function guardarUsuario() {
      guardando.value = true
      try {
        await permisosApi.editarUsuario(abierto.value.id, { ...edicion })
        avisar(`Usuario ${abierto.value.username} actualizado`)
        abierto.value = null
        await cargar()
        refrescarMisPermisos()
      } catch (e) { fallo(e) } finally { guardando.value = false }
    }
    async function guardarClave() {
      if (clave1.value !== clave2.value) { error.value = 'Las contraseñas no coinciden'; return }
      guardando.value = true
      try {
        await permisosApi.cambiarClave(abierto.value.id, clave1.value)
        avisar(`Contraseña de ${abierto.value.username} cambiada`)
        abierto.value = null
      } catch (e) { fallo(e) } finally { guardando.value = false; clave1.value = ''; clave2.value = '' }
    }

    // ---- Grupos: matriz de niveles (0 sin acceso, 1 leer, 2 escribir) por objeto ----
    const grupoSel = ref(null)
    const niveles = reactive({})

    function elegirGrupo(g) {
      error.value = null
      for (const k of Object.keys(niveles)) delete niveles[k]
      niveles['*'] = 0
      for (const c of catalogo.value) niveles['cat:' + c.codigo] = 0
      if (!g) {
        grupoSel.value = { nuevo: true, codigo: '', nombre: '', descripcion: '', es_sistema: false, miembros: [] }
        return
      }
      grupoSel.value = { ...g, nuevo: false }
      for (const r of g.reglas) niveles[r.objeto] = Math.max(niveles[r.objeto] || 0, NIVEL[r.accion] || 0)
    }
    const categoriaDe = (obj) => 'cat:' + obj.split('.')[0]
    // Nivel que ya viene dado por un objeto más general
    function heredado(obj) {
      if (obj === '*') return 0
      const todo = niveles['*'] || 0
      if (obj.startsWith('cat:')) return todo
      return Math.max(todo, niveles[categoriaDe(obj)] || 0)
    }
    const efectivo = (obj) => Math.max(heredado(obj), niveles[obj] || 0)
    const miembros = (g) => g.miembros.map(id => usuarios.value.find(u => u.id === id)?.username || `#${id}`)

    function reglasDeMatriz() {
      const reglas = []
      for (const [obj, n] of Object.entries(niveles)) {
        if (n > heredado(obj)) reglas.push({ objeto: obj, accion: ACCION[n] })
      }
      return reglas
    }
    async function guardarGrupo() {
      const g = grupoSel.value
      const datos = { nombre: g.nombre, descripcion: g.descripcion || null, reglas: reglasDeMatriz() }
      guardando.value = true
      try {
        if (g.nuevo) await permisosApi.crearGrupo({ codigo: g.codigo, ...datos })
        else await permisosApi.editarGrupo(g.codigo, datos)
        avisar(`Grupo ${g.nombre} guardado`)
        await cargar()
        elegirGrupo(grupos.value.find(x => x.codigo === g.codigo))
        refrescarMisPermisos()
      } catch (e) { fallo(e) } finally { guardando.value = false }
    }
    async function borrarGrupo() {
      const g = grupoSel.value
      if (!confirm(`¿Borrar el grupo «${g.nombre}»? Sus ${g.miembros.length} miembros pierden los permisos que les daba.`)) return
      guardando.value = true
      try {
        await permisosApi.borrarGrupo(g.codigo)
        avisar(`Grupo ${g.nombre} borrado`)
        grupoSel.value = null
        await cargar()
      } catch (e) { fallo(e) } finally { guardando.value = false }
    }

    onMounted(cargar)

    return {
      TABS, CLAVE_MINIMA, NOMBRE_NIVEL, puedeConfig, tab, cargando, guardando, error, ok,
      catalogo, grupos, usuarios, auditoria, fecha, nombreGrupo,
      usuarioVacio, nuevoUsuario, crearUsuario, abierto, modo, edicion, clave1, clave2, efectivos,
      abrir, guardarUsuario, guardarClave,
      grupoSel, niveles, elegirGrupo, heredado, efectivo, miembros, guardarGrupo, borrarGrupo,
    }
  }
}
</script>

<style scoped>
.permisos { max-width: 1200px; margin: 0 auto; padding: 1.5rem 1rem; }
.encabezado { display: flex; justify-content: space-between; align-items: baseline; flex-wrap: wrap; gap: 1rem; margin-bottom: 1rem; }
.link-secundario { color: #4299e1; text-decoration: none; }
.tabs { display: flex; gap: .25rem; border-bottom: 2px solid #e2e8f0; margin-bottom: 1rem; flex-wrap: wrap; }
.tabs button { background: none; border: none; padding: .6rem 1rem; cursor: pointer; color: #4a5568; font-size: 1rem; border-bottom: 3px solid transparent; margin-bottom: -2px; }
.tabs button.activa { color: #2b6cb0; border-bottom-color: #4299e1; font-weight: 600; }
.msg { padding: .6rem 1rem; border-radius: 4px; margin-bottom: 1rem; }
.msg.error { background: #fed7d7; color: #9b2c2c; }
.msg.exito { background: #c6f6d5; color: #276749; }
.cargando { color: #718096; padding: 1rem 0; }
.btn { background: #4299e1; color: #fff; border: none; border-radius: 4px; padding: .5rem 1rem; cursor: pointer; font-size: .95rem; margin: 0 .4rem .4rem 0; }
.btn:hover { background: #3182ce; }
.btn:disabled { opacity: .6; cursor: default; }
.btn.chico { padding: .25rem .6rem; font-size: .85rem; }
.btn.gris { background: #a0aec0; }
.btn.rojo { background: #e53e3e; }
.tarjeta { background: #fff; border: 1px solid #e2e8f0; border-radius: 6px; padding: 1rem; margin: .5rem 0 1rem; }
.campos { display: flex; flex-wrap: wrap; gap: .75rem 1rem; margin-bottom: .75rem; }
.campos label { display: flex; flex-direction: column; font-size: .85rem; color: #4a5568; min-width: 200px; }
.campos label.ancho { flex: 1; min-width: 260px; }
.campos label.en-linea { flex-direction: row; align-items: center; gap: .4rem; }
.campos input:not([type=checkbox]) { padding: .4rem .5rem; border: 1px solid #cbd5e0; border-radius: 4px; font-size: .95rem; margin-top: .2rem; }
.grupos-check { display: flex; flex-wrap: wrap; gap: .5rem 1rem; align-items: center; margin-bottom: .75rem; font-size: .9rem; }
.tabla { width: 100%; border-collapse: collapse; background: #fff; font-size: .9rem; }
.tabla th, .tabla td { text-align: left; padding: .5rem; border-bottom: 1px solid #edf2f7; vertical-align: top; }
.tabla th { background: #f7fafc; color: #4a5568; font-weight: 600; }
.tabla tr.inactivo td { color: #a0aec0; }
.tabla tr.detalle td { background: #f7fafc; }
.acciones { white-space: nowrap; }
.nowrap { white-space: nowrap; }
.sub { color: #718096; font-size: .82rem; font-weight: normal; }
.chip { display: inline-block; background: #ebf8ff; color: #2b6cb0; border-radius: 10px; padding: .05rem .55rem; margin: 0 .25rem .2rem 0; font-size: .82rem; }
.efectivos { margin: .5rem 0 1rem 1rem; }
.efectivos ul { margin-left: 1.2rem; }
.nivel-escribir { color: #276749; font-weight: 600; }
.nivel-leer { color: #2b6cb0; }
.grupos-layout { display: flex; gap: 1rem; align-items: flex-start; }
.lista-grupos { display: flex; flex-direction: column; min-width: 200px; gap: .25rem; }
.lista-grupos button { text-align: left; background: #fff; border: 1px solid #e2e8f0; border-radius: 4px; padding: .5rem .75rem; cursor: pointer; }
.lista-grupos button.activa { border-color: #4299e1; background: #ebf8ff; }
.lista-grupos button.nuevo { color: #4299e1; border-style: dashed; }
.editor-grupo { flex: 1; margin-top: 0; overflow-x: auto; }
.matriz { width: 100%; border-collapse: collapse; font-size: .9rem; margin: .5rem 0 1rem; }
.matriz th, .matriz td { padding: .35rem .5rem; border-bottom: 1px solid #edf2f7; }
.matriz th:not(:first-child), .matriz td:not(:first-child) { text-align: center; width: 110px; }
.matriz .fila-todo td { background: #fefcbf; }
.matriz .fila-cat td { background: #f7fafc; }
.matriz .fila-rec td:first-child { padding-left: 1.75rem; }
.detalle-json { font-size: .78rem; color: #4a5568; word-break: break-word; }
@media (max-width: 800px) {
  .grupos-layout { flex-direction: column; }
  .lista-grupos { flex-direction: row; flex-wrap: wrap; min-width: 0; }
  .tabla { font-size: .82rem; }
  .acciones { white-space: normal; }
}
</style>
